import { render, staticRenderFns } from "./DbManagement.vue?vue&type=template&id=6bd87a82&scoped=true&"
import script from "./DbManagement.vue?vue&type=script&lang=js&"
export * from "./DbManagement.vue?vue&type=script&lang=js&"
import style0 from "./DbManagement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DbManagement.vue?vue&type=style&index=1&id=6bd87a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd87a82",
  null
  
)

export default component.exports